/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconInnerShadowRight = createReactComponent("outline", "inner-shadow-right", "IconInnerShadowRight", [["path", { "d": "M18.364 18.364a9 9 0 1 1 -12.728 -12.728a9 9 0 0 1 12.728 12.728z", "key": "svg-0" }], ["path", { "d": "M16.243 7.757a6 6 0 0 1 0 8.486", "key": "svg-1" }]]);

export { IconInnerShadowRight as default };
//# sourceMappingURL=IconInnerShadowRight.mjs.map
